import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import { withStyles } from '@mui/styles';
import {useSnackbar} from "notistack";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {useNavigate,Link} from "react-router-dom";
import {defaultVariables} from "../../../../../config";
import SwiperSlider from "../../../../components/elements/slider/SwiperSlider";
import CharityCardFront from "../../components/charities/CharityCardFront";
import {Styles} from "../../../../../config/design/styles";
import Title from "../../../../components/elements/Title";
import {Button} from "@mui/material";
import { ChevronRight } from 'lucide-react';


function CharitiesSlider({classes,industry}){
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setLoading(true);
        axios.get(`${defaultVariables.url}/front/get-charities-for-slider`,config)
            .then(response => {
                setData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        loadData();
    },[]);


    return (
        <Grid container spacing={2}>
            {
                data.length > 0 &&
                <>
                    <Grid item size={12} className="flex-space">
                        <Title align='left' color='text'>{t('charities')}</Title>
                        <Button
                            component={Link}
                            endIcon={<ChevronRight/>}
                            to={"/charities"}
                        >
                            {t('viewAll')}
                        </Button>
                    </Grid>
                    <Grid item size={12}>
                        <SwiperSlider
                            data={data}
                            spaceBetween={20}
                            slidesPerView={1.3}
                            showNavigation={true}
                            renderSlide={(vendor) => <CharityCardFront item={vendor} />}
                            breakpoints={{
                                450: { slidesPerView: 1.2 },
                                576: { slidesPerView: 2.2 },
                                768: { slidesPerView: 2.3 },
                                992: { slidesPerView: 3.3 },
                                1280: { slidesPerView: 3.8 },
                                1500: { slidesPerView: 4.5 },
                            }}
                        />
                    </Grid>
                </>
            }
        </Grid>
    );
}
export default withStyles(Styles)(CharitiesSlider);
